<template>
  <gj-modal
      notFooterPadding
      size="1300_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增商品投放</template>
    <template #content>
      <el-form
        ref="form"
        :model="form">
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :targetingType="1"
            @campaignChange="campaignChange"
        ></app-base-info>
        <app-product-target-picker
            ref="picker"
            :market-id="marketId"
            :currencySymbol="adStore.SB.currencySymbol"
            :params="params"
            :form="form.productTargetPickerForm"
            title="商品投放"
            :bid="adStore.SB.defaultBid"
        ></app-product-target-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import { adStore } from "@/views/modules/ad/common/store";
import {modalMixIn} from "@/minxins";
import AppBaseInfo from "../common/sb-base-info";
import AppProductTargetPicker from "../common/product-target-picker";
import {AdGroupEnum} from "@/views/modules/ad/common/enum";
import {defaultVal, isMeaningful} from "@/utils/common";
import { adsSbProductTargetingCreate } from "@/api/ad";

export default {
  name: "app-add-sp-ad-product-target",
  mixins: [modalMixIn],
  components: {AppProductTargetPicker, AppBaseInfo},
  props: {
    marketId: {
      required: true
    },
    campaign: {
      required: false,
      default: null
    },
    group: {
      required: false,
      default: null
    }
  },
  data() {
    return {
      adStore,
      params: {
        adFormat: null
      },
      form: {
        baseInfoForm: {
          campaignId: null,
        },
        productTargetPickerForm: {
          items: [],
          bid: null
        }
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 切换广告活动
    campaignChange(campaignId, options) {
      this.$refs.picker.getSuggestedClassification({ campaignId })
      let item = options.find(e => e.campaignId == campaignId)
      this.params.adFormat = item.adFormat
      this.$refs.picker.getRecommendedASIN({ campaignId })
    },
    inputGroupOption(option) {
      if (isMeaningful(option)) {
        this.form.productTargetPickerForm.bid = option.bid;
      }
    },
    confirm() {
      const formValid = !['base', 'picker'].some(e => !this.$refs[e].formValidate());
      if (formValid) {
        this.confirmLoading = true;
        const params = {
          marketId: this.marketId,
          targetsBeansVo: this.form.productTargetPickerForm.items.map(item => ({
            id: item.categoryId || null,
            asin: item.asin || null,
            brandId: item.brandId || null,
            lowPrice: item.lowPrice || null,
            maxPrice: item.maxPrice || null,
            marks: item.marks || null,
            bid: item.bid,
            categoryName: item.categoryName || null,
            campaignId: this.form.baseInfoForm.campaignId,
            groupId: this.form.baseInfoForm.groupId,
          }))
        }
        adsSbProductTargetingCreate(params)
          .then(() => {
            this.$gjDestroy();
            this.$emit('created');
          })
          .complete(() => this.confirmLoading = false);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.adStore.SB.campaign?.campaignId && this.campaignChange(this.adStore.SB.campaign.campaignId)
        this.adStore.SB.campaign?.adFormat && (this.params.adFormat = item.adFormat)
      }, 100);
    })
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";

</style>
